import { Subscription } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { MediaChange, MediaObserver } from '@angular/flex-layout';
import { Component, OnInit, ViewEncapsulation } from '@angular/core';


import { Player } from 'app/shared/model';
import { MatDialogRef } from '@angular/material/dialog';

let apiLoaded = false;

@Component({
  selector: 'clearcals-video-player',
  templateUrl: './video-player.component.html',
  styleUrls: ['./video-player.component.scss'],
  encapsulation: ViewEncapsulation.None
})
class VideoPlayerComponent implements OnInit {

  videoId: string;
  player: Player;
  mediaSubscription: Subscription;

  constructor(
    private mediaObserver: MediaObserver,
    public dialogRef: MatDialogRef<VideoPlayerComponent>,)
  {
      this.mediaSubscription = this.mediaObserver.asObservable()
      .pipe(
        filter((changes: MediaChange[]) => changes.length > 0),
        map((changes: MediaChange[]) => changes[0])
      )
      .subscribe((change: MediaChange) => this.setInitialWidth(change));
  }

  setInitialWidth(change: MediaChange): void
  {
      if (change.mqAlias === 'xs' || change.mqAlias === 'sm')
      {
          this.player = new Player ({ videoId: this.videoId, width: 320, height: 420 });
      }
      else
      {
          this.player = new Player ({ videoId: this.videoId });
      }
  }

  ngOnInit(): void
  {
      if (!apiLoaded) {
        // This code loads the IFrame Player API code asynchronously, according to the instructions at
        // https://developers.google.com/youtube/iframe_api_reference#Getting_Started
        const tag = document.createElement('script');
        tag.src = 'https://www.youtube.com/iframe_api';
        document.body.appendChild(tag);
        apiLoaded = true;
      }
  }

}

export default VideoPlayerComponent;
